import React, { useContext, useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  TextField,
  InputAdornment,
  Button,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
//Icons
import { LuSearch } from "react-icons/lu";
import romdul from "../../Assets/romdul.png";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";

//Srcs
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import FooterPagination from "../../Components/Include/FooterPagination";
import { GET_GROUP_PAGINATION } from "../../Schema/Group";
import { useMutation, useQuery } from "@apollo/client";
import GroupAction from "../../Components/Group/GroupAction";
import GroupForm from "../../Components/Group/GroupForm";

export default function Group() {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpen = () => setOpenCreate(true);
  const handleClose = () => setOpenCreate(false);

  const [tableData, setTableData] = useState();
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { refetch } = useQuery(GET_GROUP_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
    },
    onCompleted: ({ getGroupPagination }) => {
      setTableData(getGroupPagination?.data);
      setPaginationData(getGroupPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // console.log("tableData::::", tableData);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/setting">
              <Typography
                className={language === "kh" ? "page-title-kh" : "page-title"}
              >
                {t(`page-setting`)}
              </Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="slash-title">/</Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`group`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`label-search`)}
            </Typography>
            <TextField
              placeholder={t(`label-search`)}
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#158843", fontSize: "22px" }}
                  >
                    <LuSearch />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 10 }}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create-style"
                startIcon={
                  // <img src={romdul} alt="romdul" className="icon-add" />
                  <AddToPhotosIcon className="icon-add" />
                }
              >
                <Typography
                  className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                >
                  {t("btn-create")}
                </Typography>
              </Button>
            </Stack>
            <GroupForm
              open={openCreate}
              handleClose={handleClose}
              setRefetch={refetch}
              dialogTitle="Create"
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("group_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("remark")}
                </TableCell>

                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                            >
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.group_name}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.remark}
                            </TableCell>

                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="right"
                            >
                              <GroupAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          // setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
